export default __webpack_public_path__ + "static/media/grid.b02c14e4.svg";